export const localeFallbacks = {"en":null,"fr":"en","ja":"en","ru":"en","zh":"en","it":"en","nl":"en","ar":"en","de":"en","es":"en","pt":"en"};
